import { ContactUsPriority } from '@marketspark/common/enums';
export { SHARED_ROUTE_NAMES } from './routes.constants';

export const contactUsPriorityToolTip: Record<ContactUsPriority, string> = {
  [ContactUsPriority.CRITICAL]: '>20% of customer lines down, or life-safety line down',
  [ContactUsPriority.URGENT]: '<20% of lines down, or all lines down at one site',
  [ContactUsPriority.HIGH]: 'One non-life-safety line down at one site',
  [ContactUsPriority.NORMAL]:
    'Account/admin requests, including CMDC access, users, or line changes',
};

export const ServiceStatuses = ['total', 'online', 'offline', 'trouble', 'none'];

export const MIX_DOMAIN_REGEX = new RegExp(/^(?:[a-zA-Z0-9]+\.){2}pbx\.supersip\.net$/);
export const MIX_PORTAL_URL = 'https://my.mixnetworks.com/portal/domains/manage/';
export const N2P_PORTAL_URL = 'https://ncthv.net2phone.com/portal/domains/manage/';

export const MARKETSPARK_EMAIL = '@marketspark.com';
export const MARKETSPARK_SUPPORT_NUMBER = '18443355153';

export const DEFAULT_PAGE_LIMIT = 10;
